const ARS = new Intl.NumberFormat("es-AR", {
  style: "currency",
  currency: "ARS",
  maximumFractionDigits: 0,
});

const ARS_DEC = new Intl.NumberFormat("es-AR", {
  style: "currency",
  currency: "ARS",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const NUM = new Intl.NumberFormat("es-AR", { maximumFractionDigits: 0 });
const NUM_DEC = new Intl.NumberFormat("es-AR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const PCT = new Intl.NumberFormat("es-AR", {
  style: "percent",
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export function formatArs(value: number, decimals = false): string {
  if (!Number.isFinite(value)) return "—";
  return (decimals ? ARS_DEC : ARS).format(value);
}

export function formatNumber(value: number, decimals = 0): string {
  if (!Number.isFinite(value)) return "—";
  return decimals > 0 ? NUM_DEC.format(value) : NUM.format(Math.round(value));
}

export function formatPct(value: number): string {
  if (!Number.isFinite(value)) return "—";
  return PCT.format(value);
}

export function formatSignedArs(value: number): string {
  if (!Number.isFinite(value)) return "—";
  if (value === 0) return formatArs(0);
  const sign = value > 0 ? "+" : "−";
  return `${sign}${formatArs(Math.abs(value))}`;
}

export function clamp(value: number, min: number, max: number): number {
  if (!Number.isFinite(value)) return min;
  return Math.min(max, Math.max(min, value));
}

export function roundClients(count: number, pct: number): number {
  if (count <= 0 || pct <= 0) return 0;
  return Math.round(count * clamp(pct, 0, 1));
}

export function newProjectionId(prefix = "id"): string {
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}
